export interface CharacterInfo {
  name: string;
  actor: string;
  image: string;
  desc: string;
}

export interface Series {
  id: string;
  title: string;
  year: number;
  category: string;
  region: string;
  rating: number;
  episodes: number;
  director: string;
  writers: string;
  cast: string[];
  hot: number;
  tags: string[];
  poster: string;
  backdrop: string;
  summary: string[];
  characters: CharacterInfo[];
}

export const seriesList: Series[] = [
  {
    id: "xianjian-1",
    title: "仙剑奇侠传",
    year: 2005,
    category: "正传",
    region: "港台",
    rating: 9.1,
    episodes: 34,
    director: "李国立",
    writers: "邓紫珊、陈翘英",
    cast: ["胡歌", "刘亦菲", "安以轩", "彭于晏"],
    hot: 98,
    tags: ["仙侠", "经典", "宿命"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20xianxia%20fantasy%20drama%20poster%2C%20ink%20green%20and%20pale%20gold%20palette%2C%20misty%20immortal%20mountains%2C%20young%20swordsman%20in%20flowing%20white%20robes%2C%20cel%20shaded%20painterly%20illustration%2C%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=xj-poster-01&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Panoramic%20stylized%20xianxia%20landscape%2C%20floating%20mountain%20peaks%20above%20sea%20of%20clouds%2C%20ink%20green%20and%20gold%20atmosphere%2C%20ethereal%20light%20rays%2C%20Chinese%20fantasy%20painting%20style%2C%20no%20text&width=1280&height=720&seq=xj-back-01&orientation=landscape",
    summary: [
      "渝州城渔村少年李逍遥自幼与婶婶相依为命，一次偶然的际遇让他踏上仙岛，结识了女娲后人赵灵儿，也由此卷入一段跨越人魔仙三界的宿命纠葛。",
      "为护送灵儿返回故乡南诏，李逍遥与林家堡千金林月如、唐门少主唐钰等人一路同行，历经锁妖塔、水魔兽等重重磨难。欢笑与泪水交织的旅途里，友情、亲情与爱意被推向极致。",
      "当宿命的指针开始转动，少年们不得不在守护苍生与守护所爱之间做出抉择。这段关于成长与牺牲的故事，成为无数观众心中仙侠剧的起点。",
    ],
    characters: [
      {
        name: "李逍遥",
        actor: "胡歌",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20handsome%20young%20Chinese%20swordsman%20in%20white%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20background%20with%20gold%20mist%2C%20heroic%20gentle%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-01a&orientation=portrait",
        desc: "渝州少年，天性洒脱重情。机缘之下习得御剑之术，从懵懂店小二成长为肩负苍生的侠者。",
      },
      {
        name: "赵灵儿",
        actor: "刘亦菲",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20gentle%20young%20Chinese%20immortal%20lady%20in%20soft%20green%20and%20white%20dress%2C%20long%20flowing%20hair%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20misty%20background%2C%20serene%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-01b&orientation=portrait",
        desc: "女娲后人，仙灵岛少女。纯真善良却承载着守护南诏、封印水魔兽的沉重宿命。",
      },
      {
        name: "林月如",
        actor: "安以轩",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20spirited%20young%20Chinese%20swordswoman%20in%20red%20and%20green%20martial%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20background%20with%20gold%20accents%2C%20determined%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-01c&orientation=portrait",
        desc: "林家堡千金，刁蛮却深情。一把长剑走天涯，用义无反顾的守护诠释了何为“爱而不得的成全”。",
      },
    ],
  },
  {
    id: "xianjian-3",
    title: "仙剑奇侠传三",
    year: 2009,
    category: "正传",
    region: "港台",
    rating: 8.6,
    episodes: 37,
    director: "李国立",
    writers: "邓紫珊、洪亮",
    cast: ["胡歌", "杨幂", "霍建华", "唐嫣"],
    hot: 95,
    tags: ["仙侠", "轮回", "宿命"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20xianxia%20fantasy%20drama%20poster%2C%20two%20figures%20in%20red%20and%20blue%20robes%20amid%20flying%20swords%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20painterly%20illustration%2C%20dramatic%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=xj-poster-02&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Stylized%20xianxia%20battle%20landscape%2C%20ancient%20Chinese%20city%20above%20clouds%20with%20glowing%20sword%20auras%2C%20ink%20green%20and%20warm%20gold%20sky%2C%20Chinese%20fantasy%20painting%20style%2C%20no%20text&width=1280&height=720&seq=xj-back-02&orientation=landscape",
    summary: [
      "渝州城当铺伙计景天，与大小姐雪见因一枚玉佩相遇，又因各自前世今生的牵绊而被卷入寻找五灵珠、镇守锁妖塔的旅途。",
      "前世飞蓬将军与夕瑶、雪见之间的轮回恩怨，徐长卿与紫萱三生三世的爱恨纠缠，让这段冒险既有热血也有难解的深情。",
      "当“此生不负”与“来世再续”同时摆在眼前，少年们用各自的抉择回答了命运抛出的难题，也留下了一代人的荧幕记忆。",
    ],
    characters: [
      {
        name: "景天",
        actor: "胡歌",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20cheerful%20young%20Chinese%20swordsman%20in%20red%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20background%20with%20gold%20mist%2C%20confident%20smile%2C%20no%20text&width=420&height=520&seq=xj-char-02a&orientation=portrait",
        desc: "渝州当铺伙计，前世为飞蓬将军。市井机灵却重情重义，是队伍里永远的气氛担当。",
      },
      {
        name: "雪见",
        actor: "杨幂",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20lively%20young%20Chinese%20lady%20in%20blue%20and%20white%20dress%2C%20cel%20shaded%20xianxia%20character%20art%2C%20misty%20green%20background%20with%20gold%20light%2C%20bright%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-02b&orientation=portrait",
        desc: "唐门大小姐，前世为夕瑶。骄纵外表下藏着一颗柔软赤诚的心，敢爱敢恨。",
      },
      {
        name: "徐长卿",
        actor: "霍建华",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20stoic%20young%20Chinese%20immortal%20daoist%20in%20white%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20deep%20ink%20green%20background%20with%20gold%20rim%20light%2C%20calm%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-02c&orientation=portrait",
        desc: "蜀山派弟子，三生三世痴情不改。以“道”为念，却始终放不下心中那一人。",
      },
      {
        name: "紫萱",
        actor: "唐嫣",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20an%20elegant%20Chinese%20immortal%20lady%20in%20purple%20and%20gold%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20misty%20background%2C%20melancholic%20grace%2C%20no%20text&width=420&height=520&seq=xj-char-02d&orientation=portrait",
        desc: "女娲后人，为爱守候百年。带着前世记忆寻找命定的那个人，痴情而坚忍。",
      },
    ],
  },
  {
    id: "xianjian-4",
    title: "仙剑奇侠传四",
    year: 2024,
    category: "正传",
    region: "大陆",
    rating: 7.2,
    episodes: 36,
    director: "杨玄",
    writers: "张炭",
    cast: ["鞠婧祎", "陈哲远", "茅子俊"],
    hot: 88,
    tags: ["仙侠", "寻道", "新作"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20xianxia%20drama%20poster%2C%20two%20young%20cultivators%20beneath%20a%20giant%20ancient%20sword%2C%20ink%20green%20and%20pale%20gold%20palette%2C%20cel%20shaded%20painterly%20illustration%2C%20epic%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=xj-poster-03&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Stylized%20xianxia%20mountain%20gate%20landscape%2C%20ancient%20immortal%20sect%20above%20clouds%2C%20ink%20green%20and%20gold%20radiance%2C%20Chinese%20fantasy%20painting%20style%2C%20no%20text&width=1280&height=720&seq=xj-back-03&orientation=landscape",
    summary: [
      "昆仑山弟子云天河自幼独居山中，与闯入结界的少女韩菱纱、慕容紫英相遇，为探寻身世与修仙真义踏上云游之路。",
      "从青鸾峰到琼华派，少年们在天道与人心的抉择间不断成长，也逐渐揭开上一代遗留下来的恩怨。",
      "“寻仙”与“问心”在这部作品中交织，讲述了一个关于执念、道义与释怀的仙侠故事。",
    ],
    characters: [
      {
        name: "云天河",
        actor: "陈哲远",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20simple%20honest%20young%20Chinese%20cultivator%20in%20earth%20tone%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20background%20with%20gold%20mist%2C%20pure%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-03a&orientation=portrait",
        desc: "自幼生长于青鸾峰的少年，天性纯善，不通世事却心怀赤诚，一根竹杖走遍山河。",
      },
      {
        name: "韩菱纱",
        actor: "鞠婧祎",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20bright%20young%20Chinese%20girl%20in%20yellow%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20misty%20green%20background%2C%20playful%20smile%2C%20no%20text&width=420&height=520&seq=xj-char-03b&orientation=portrait",
        desc: "乐观机灵的江湖少女，背负家族使命，用笑容掩去身世的沉重，敢做敢当。",
      },
      {
        name: "慕容紫英",
        actor: "茅子俊",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20cold%20elegant%20young%20Chinese%20swordsman%20in%20white%20and%20silver%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20deep%20ink%20green%20background%2C%20aloof%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-03c&orientation=portrait",
        desc: "慕容世家少主，剑术卓绝、性情清冷。在道义与人情之间反复求索，最终学会何为“情”。",
      },
    ],
  },
  {
    id: "qijinzhao",
    title: "仙剑六·祈今朝",
    year: 2024,
    category: "续集",
    region: "大陆",
    rating: 6.9,
    episodes: 40,
    director: "高翊浚",
    writers: "贾东岩",
    cast: ["许凯", "虞书欣", "付辛博"],
    hot: 80,
    tags: ["仙侠", "江湖", "新作"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20xianxia%20drama%20poster%2C%20a%20swordsman%20and%20a%20young%20lady%20before%20a%20glowing%20seal%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20painterly%20illustration%2C%20mysterious%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=xj-poster-04&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Stylized%20xianxia%20ancient%20town%20at%20dusk%20beside%20a%20river%2C%20lanterns%20and%20mist%2C%20ink%20green%20and%20gold%20tones%2C%20Chinese%20fantasy%20painting%20style%2C%20no%20text&width=1280&height=720&seq=xj-back-04&orientation=landscape",
    summary: [
      "越祈与扁络桓为探寻身世谜团同行江湖，在祈今朝的世界里面对家国、江湖与情义的层层考验。",
      "围绕太一仙门的纷争，两人结识各路豪杰，也在阴谋与背叛中逐渐明晰彼此的心意。",
      "作品延续仙剑系列的江湖气韵，以剑与情为线，勾勒一段跌宕起伏的成长旅程。",
    ],
    characters: [
      {
        name: "越祈",
        actor: "许凯",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20gentle%20young%20Chinese%20swordsman%20in%20blue%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20background%20with%20gold%20mist%2C%20thoughtful%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-04a&orientation=portrait",
        desc: "身世成谜的江湖少侠，性格温润而坚韧，一心探寻真相，也在守护中学会担当。",
      },
      {
        name: "扁络桓",
        actor: "虞书欣",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20lively%20young%20Chinese%20lady%20in%20pink%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20misty%20green%20background%2C%20cheerful%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-04b&orientation=portrait",
        desc: "机灵跳脱的江湖少女，医术与轻功俱佳，用乐观化解一路的险难。",
      },
      {
        name: "临渊",
        actor: "付辛博",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20mature%20young%20Chinese%20nobleman%20in%20dark%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20deep%20ink%20green%20background%2C%20composed%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-04c&orientation=portrait",
        desc: "深藏心机的世家公子，亦正亦邪。在权谋与情义之间走出属于自己的路。",
      },
    ],
  },
  {
    id: "youjianxiaoyao",
    title: "又见逍遥",
    year: 2024,
    category: "衍生",
    region: "大陆",
    rating: 7.5,
    episodes: 40,
    director: "张英姬",
    writers: "张英姬",
    cast: ["何与", "杨雨潼", "徐好"],
    hot: 78,
    tags: ["仙侠", "重制", "经典"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20xianxia%20drama%20poster%2C%20a%20young%20swordsman%20gazing%20at%20floating%20islands%2C%20ink%20green%20and%20pale%20gold%20palette%2C%20cel%20shaded%20painterly%20illustration%2C%20nostalgic%20cinematic%20composition%2C%20no%20text&width=600&height=900&seq=xj-poster-05&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Stylized%20xianxia%20immortal%20island%20above%20the%20clouds%2C%20waterfalls%20and%20ancient%20pavilions%2C%20ink%20green%20and%20gold%20glow%2C%20Chinese%20fantasy%20painting%20style%2C%20no%20text&width=1280&height=720&seq=xj-back-05&orientation=landscape",
    summary: [
      "作为经典之作的全新演绎，《又见逍遥》以当代视角重述李逍遥与赵灵儿的仙侠奇缘。",
      "重制版在保留原作精神内核的同时，以更细腻的笔触刻画人物成长与情感抉择。",
      "熟悉的故事有了新的呼吸，也邀请新一代观众走进这段跨越时光的仙侠记忆。",
    ],
    characters: [
      {
        name: "李逍遥",
        actor: "何与",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20youthful%20Chinese%20swordsman%20in%20white%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20background%20with%20gold%20mist%2C%20warm%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-05a&orientation=portrait",
        desc: "重制版中的渝州少年，依旧仗义洒脱，在崭新的叙事里重新诠释侠者的成长。",
      },
      {
        name: "赵灵儿",
        actor: "杨雨潼",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20pure%20young%20Chinese%20immortal%20lady%20in%20light%20green%20dress%2C%20cel%20shaded%20xianxia%20character%20art%2C%20misty%20green%20background%2C%20gentle%20smile%2C%20no%20text&width=420&height=520&seq=xj-char-05b&orientation=portrait",
        desc: "仙灵岛的少女，天真温柔，背负守护众生的使命，是故事里最温柔也最坚强的存在。",
      },
      {
        name: "林月如",
        actor: "徐好",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20bold%20young%20Chinese%20swordswoman%20in%20red%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20background%2C%20spirited%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-05c&orientation=portrait",
        desc: "林家的刁蛮千金，剑法凌厉，爱得坦荡，用一腔孤勇守护心中所念。",
      },
    ],
  },
  {
    id: "zhuxian",
    title: "诛仙青云志",
    year: 2016,
    category: "相关",
    region: "大陆",
    rating: 7.0,
    episodes: 55,
    director: "朱锐斌",
    writers: "邵潇逸",
    cast: ["李易峰", "赵丽颖", "杨紫"],
    hot: 76,
    tags: ["仙侠", "玄幻", "正邪"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20xianxia%20drama%20poster%2C%20a%20young%20cultivator%20before%20a%20giant%20bamboo%20forest%20and%20glowing%20orb%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20painterly%20illustration%2C%20no%20text&width=600&height=900&seq=xj-poster-06&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Stylized%20xianxia%20bamboo%20forest%20with%20floating%20light%20orbs%2C%20ink%20green%20and%20gold%20atmosphere%2C%20Chinese%20fantasy%20painting%20style%2C%20mysterious%20mood%2C%20no%20text&width=1280&height=720&seq=xj-back-06&orientation=landscape",
    summary: [
      "草庙村少年张小凡历经家破人亡，被青云门收留，与陆雪琪、碧瑶之间展开一段纠缠半生的情缘。",
      "在正邪难辨的乱世里，张小凡被卷入门派与魔教之争，一步步走向命运的岔路。",
      "作品以仙侠为幕，探讨善恶与执念的边界，是一部充满玄幻色彩的经典改编。",
    ],
    characters: [
      {
        name: "张小凡",
        actor: "李易峰",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20an%20ordinary%20young%20Chinese%20cultivator%20in%20grey%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20bamboo%20background%2C%20resilient%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-06a&orientation=portrait",
        desc: "草庙村孤儿，质朴坚韧。历经磨难仍守本心，在正邪之间寻找属于自己的答案。",
      },
      {
        name: "陆雪琪",
        actor: "杨紫",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20cold%20elegant%20young%20Chinese%20swordswoman%20in%20white%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20misty%20green%20background%20with%20gold%20light%2C%20serene%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-06b&orientation=portrait",
        desc: "青云门小竹峰弟子，清冷孤傲的天才剑修。以剑护道，情藏于心的侠女典范。",
      },
      {
        name: "碧瑶",
        actor: "赵丽颖",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20vivid%20young%20Chinese%20lady%20in%20green%20and%20gold%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20deep%20ink%20green%20background%2C%20bold%20loving%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-06c&orientation=portrait",
        desc: "鬼王宗少主，敢爱敢恨。为护心中之人奋不顾身，是剧中最令人难忘的身影之一。",
      },
    ],
  },
  {
    id: "gujianqitan",
    title: "古剑奇谭",
    year: 2014,
    category: "相关",
    region: "大陆",
    rating: 7.6,
    episodes: 50,
    director: "梁胜权",
    writers: "某年",
    cast: ["杨幂", "李易峰", "乔振宇"],
    hot: 74,
    tags: ["仙侠", "奇幻", "寻剑"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20xianxia%20drama%20poster%2C%20a%20swordsman%20with%20a%20glowing%20ancient%20sword%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20painterly%20illustration%2C%20epic%20fantasy%20composition%2C%20no%20text&width=600&height=900&seq=xj-poster-07&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Stylized%20xianxia%20valley%20with%20giant%20sunflower%20field%20and%20distant%20peaks%2C%20ink%20green%20and%20gold%20light%2C%20Chinese%20fantasy%20painting%20style%2C%20no%20text&width=1280&height=720&seq=xj-back-07&orientation=landscape",
    summary: [
      "百里屠苏身负焚寂剑煞气，在欧阳少恭、风晴雪等人的陪伴下踏上寻找身世与化解煞气的旅途。",
      "从幽都到蓬莱，一路上结识挚友、遭遇宿敌，也逐渐拼凑出一段跨越千年的前尘旧事。",
      "作品以剑为媒，讲述关于羁绊与救赎的故事，是仙侠改编剧中的代表作之一。",
    ],
    characters: [
      {
        name: "百里屠苏",
        actor: "李易峰",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20silent%20young%20Chinese%20swordsman%20in%20dark%20green%20and%20black%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20background%20with%20gold%20rim%2C%20stoic%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-07a&orientation=portrait",
        desc: "背负焚寂煞气的少年剑客，沉默寡言却重情重义，在寻找自我的路上不断前行。",
      },
      {
        name: "风晴雪",
        actor: "杨幂",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20cheerful%20young%20Chinese%20girl%20in%20yellow%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20misty%20green%20background%20with%20gold%20light%2C%20bright%20smile%2C%20no%20text&width=420&height=520&seq=xj-char-07b&orientation=portrait",
        desc: "幽都少女，乐观开朗，擅长医术。用温暖治愈伙伴，也成了屠苏心中最明亮的光。",
      },
      {
        name: "欧阳少恭",
        actor: "乔振宇",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20an%20elegant%20young%20Chinese%20nobleman%20in%20white%20and%20gold%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20deep%20ink%20green%20background%2C%20sophisticated%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-07c&orientation=portrait",
        desc: "温润如玉的世家公子，心怀执念。光风霁月的外表下藏着难解的过往与深情。",
      },
    ],
  },
  {
    id: "huqiangu",
    title: "花千骨",
    year: 2015,
    category: "相关",
    region: "大陆",
    rating: 6.9,
    episodes: 58,
    director: "高林豹",
    writers: "边距",
    cast: ["霍建华", "赵丽颖", "蒋欣"],
    hot: 72,
    tags: ["仙侠", "师徒", "虐恋"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20xianxia%20drama%20poster%2C%20a%20young%20immortal%20lady%20and%20a%20white%20robed%20master%20amid%20floating%20petals%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20painterly%20illustration%2C%20romantic%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=xj-poster-08&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Stylized%20xianxia%20immortal%20palace%20gardens%20with%20falling%20petals%2C%20ink%20green%20and%20gold%20atmosphere%2C%20Chinese%20fantasy%20painting%20style%2C%20no%20text&width=1280&height=720&seq=xj-back-08&orientation=landscape",
    summary: [
      "花千骨拜入长留上仙白子画门下，从懵懂少女成长为独当一面的修士，师徒之情也在磨难中悄然生变。",
      "身负奇异命格的她在正邪夹缝中挣扎，随着白子画与七杀殿的恩怨浮出水面，命运将她推向无法回避的抉择。",
      "作品以师徒羁绊为核心，谱写了一段关于执念与牺牲的仙侠虐恋。",
    ],
    characters: [
      {
        name: "花千骨",
        actor: "赵丽颖",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20gentle%20young%20Chinese%20immortal%20girl%20in%20pink%20and%20white%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20misty%20background%2C%20innocent%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-08a&orientation=portrait",
        desc: "天真善良的少女，身负异命却始终赤诚。在爱恨纠葛中一步步走向成长与觉醒。",
      },
      {
        name: "白子画",
        actor: "霍建华",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20an%20aloof%20Chinese%20immortal%20master%20in%20white%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20deep%20ink%20green%20background%20with%20gold%20light%2C%20cold%20yet%20warm%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-08b&orientation=portrait",
        desc: "长留上仙，清冷绝尘、以天下为念。看似无情，实则将深情藏于道义之后。",
      },
      {
        name: "霓漫天",
        actor: "蒋欣",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20proud%20young%20Chinese%20lady%20in%20blue%20and%20purple%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20misty%20green%20background%2C%20haughty%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-08c&orientation=portrait",
        desc: "蓬莱掌门之女，骄矜而执念深重。在嫉妒与爱意的交织中走向了悲情的结局。",
      },
    ],
  },
  {
    id: "sansheng",
    title: "三生三世十里桃花",
    year: 2017,
    category: "相关",
    region: "大陆",
    rating: 7.4,
    episodes: 58,
    director: "林玉芬",
    writers: "墨宝非宝",
    cast: ["杨幂", "赵又廷", "迪丽热巴"],
    hot: 84,
    tags: ["仙侠", "三世", "仙恋"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20xianxia%20drama%20poster%2C%20a%20heavenly%20lady%20and%20a%20noble%20lord%20beneath%20peach%20blossoms%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20painterly%20illustration%2C%20ethereal%20romantic%20mood%2C%20no%20text&width=600&height=900&seq=xj-poster-09&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Stylized%20xianxia%20peach%20blossom%20heavenly%20realm%2C%20floating%20islands%20and%20clouds%2C%20ink%20green%20and%20gold%20glow%2C%20Chinese%20fantasy%20painting%20style%2C%20no%20text&width=1280&height=720&seq=xj-back-09&orientation=landscape",
    summary: [
      "九重天太子夜华与青丘女君白浅跨越三世的爱恨纠葛，从东海相识到诛仙台生死相守，情缘几经轮回。",
      "身为昆仑虚弟子的司音、凡间历劫的素素、重回青丘的白浅，三个身份的变换串联起一段缠绵悱恻的仙恋。",
      "作品以唯美的仙侠世界观著称，将三世轮回的深情讲述得荡气回肠。",
    ],
    characters: [
      {
        name: "白浅",
        actor: "杨幂",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20an%20elegant%20heavenly%20Chinese%20lady%20in%20white%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20misty%20green%20background%20with%20gold%20light%2C%20serene%20noble%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-09a&orientation=portrait",
        desc: "青丘女君，仙姿卓绝。历经三世情劫仍不改初心，是仙侠剧中极具代表性的女主。",
      },
      {
        name: "夜华",
        actor: "赵又廷",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20composed%20young%20Chinese%20heavenly%20lord%20in%20dark%20green%20and%20gold%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20deep%20ink%20green%20background%2C%20devoted%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-09b&orientation=portrait",
        desc: "九重天太子，冷峻深情。为白浅三生不悔，将守护刻进了骨血之中。",
      },
      {
        name: "白凤九",
        actor: "迪丽热巴",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20charming%20young%20Chinese%20fox%20spirit%20lady%20in%20red%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20background%20with%20gold%20mist%2C%20lively%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-09c&orientation=portrait",
        desc: "青丘小帝姬，灵动痴情。为追寻爱人不惜跋涉万年，敢爱敢追的可爱少女。",
      },
    ],
  },
  {
    id: "chenqingling",
    title: "陈情令",
    year: 2019,
    category: "相关",
    region: "大陆",
    rating: 8.0,
    episodes: 50,
    director: "郑伟文",
    writers: "墨香铜臭原著改编",
    cast: ["肖战", "王一博", "孟子义"],
    hot: 90,
    tags: ["仙侠", "江湖", "知己"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20xianxia%20drama%20poster%2C%20two%20young%20cultivators%20with%20a%20flute%20and%20a%20sword%20amid%20ink%20mist%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20painterly%20illustration%2C%20elegant%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=xj-poster-10&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Stylized%20misty%20mountain%20valley%20with%20lotus%20pond%20and%20distant%20sects%2C%20ink%20green%20and%20gold%20atmosphere%2C%20Chinese%20painting%20style%2C%20no%20text&width=1280&height=720&seq=xj-back-10&orientation=landscape",
    summary: [
      "魏无羡与蓝忘机从云深不知处相识，历经射日之征、乱葬岗等风波，从少年知己走向彼此的坚守。",
      "十六年前后的谜案层层揭开，是非曲直、人心善恶在一次次抉择中被反复审视。",
      "作品以江湖群像与知己情谊见长，是仙侠题材中兼具口碑与热度的代表作。",
    ],
    characters: [
      {
        name: "魏无羡",
        actor: "肖战",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20bright%20young%20Chinese%20cultivator%20in%20black%20and%20red%20robes%20with%20a%20flute%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20background%20with%20gold%20light%2C%20free%20spirited%20smile%2C%20no%20text&width=420&height=520&seq=xj-char-10a&orientation=portrait",
        desc: "云梦江氏弟子，洒脱不羁、重情重义。以一生践行心中的侠义与守护。",
      },
      {
        name: "蓝忘机",
        actor: "王一博",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20calm%20young%20Chinese%20cultivator%20in%20white%20and%20blue%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20deep%20ink%20green%20background%2C%20serene%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-10b&orientation=portrait",
        desc: "姑苏蓝氏二公子，端正清冷。以规矩自持，却将最深的信任给了那个不守规矩的人。",
      },
      {
        name: "江厌离",
        actor: "孟子义",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20warm%20gentle%20young%20Chinese%20lady%20in%20soft%20purple%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20misty%20green%20background%2C%20kind%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-10c&orientation=portrait",
        desc: "云梦江氏大小姐，温柔贤淑。用一碗莲藕排骨汤温暖了少年们的江湖岁月。",
      },
    ],
  },
  {
    id: "canglanjue",
    title: "苍兰诀",
    year: 2022,
    category: "相关",
    region: "大陆",
    rating: 6.9,
    episodes: 36,
    director: "伊峥",
    writers: "九鹭非香原著改编",
    cast: ["虞书欣", "王鹤棣", "张凌赫"],
    hot: 82,
    tags: ["仙侠", "魔尊", "轻喜"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20xianxia%20drama%20poster%2C%20a%20demon%20lord%20and%20a%20fairy%20girl%20amid%20crimson%20clouds%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20painterly%20illustration%2C%20dramatic%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=xj-poster-11&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Stylized%20xianxia%20sky%20realm%20and%20demon%20realm%20divided%20by%20a%20river%20of%20light%2C%20ink%20green%20and%20gold%20tones%2C%20Chinese%20fantasy%20painting%20style%2C%20no%20text&width=1280&height=720&seq=xj-back-11&orientation=landscape",
    summary: [
      "小兰花作为低阶仙子意外救下月族魔尊东方青苍，两人命运就此纠缠，从对抗到相知。",
      "为了各自的族人，他们在三界纷争中并肩前行，也在误解与守护中慢慢走近彼此。",
      "作品节奏明快、情绪饱满，是近年仙侠题材中颇受欢迎的一部作品。",
    ],
    characters: [
      {
        name: "小兰花",
        actor: "虞书欣",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20cute%20young%20Chinese%20fairy%20girl%20in%20pink%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20misty%20green%20background%20with%20gold%20light%2C%20cheerful%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-11a&orientation=portrait",
        desc: "司命殿的低阶仙子，善良乐观。看似柔弱，却有着守护所爱的勇气与坚持。",
      },
      {
        name: "东方青苍",
        actor: "王鹤棣",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20powerful%20demon%20lord%20in%20black%20and%20gold%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20deep%20ink%20green%20background%20with%20crimson%20light%2C%20intense%20gaze%2C%20no%20text&width=420&height=520&seq=xj-char-11b&orientation=portrait",
        desc: "月族魔尊，强大孤傲。冰冷外表下藏着不为人知的温柔，为小事而心动。",
      },
      {
        name: "长珩",
        actor: "张凌赫",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20gentle%20young%20Chinese%20immortal%20lord%20in%20white%20and%20silver%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20misty%20green%20background%20with%20gold%20light%2C%20kind%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-11c&orientation=portrait",
        desc: "水云天仙君，温润如玉。心怀苍生，也藏着一段未能说出口的深情。",
      },
    ],
  },
  {
    id: "shushanzhanji",
    title: "轩辕剑之天之痕",
    year: 2012,
    category: "相关",
    region: "港台",
    rating: 6.8,
    episodes: 39,
    director: "李国立",
    writers: "王莉",
    cast: ["胡歌", "唐嫣", "蒋劲夫"],
    hot: 68,
    tags: ["仙侠", "轩辕剑", "宿命"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20Chinese%20xianxia%20drama%20poster%2C%20three%20young%20heroes%20with%20a%20glowing%20ancient%20sword%2C%20ink%20green%20and%20gold%20palette%2C%20cel%20shaded%20painterly%20illustration%2C%20epic%20fantasy%20composition%2C%20no%20text&width=600&height=900&seq=xj-poster-12&orientation=portrait",
    backdrop: "https://readdy.ai/api/search-image?query=Stylized%20ancient%20Chinese%20battlefield%20with%20golden%20sword%20light%20and%20clouds%2C%20ink%20green%20and%20gold%20atmosphere%2C%20Chinese%20fantasy%20painting%20style%2C%20no%20text&width=1280&height=720&seq=xj-back-12&orientation=landscape",
    summary: [
      "陈靖仇为复国踏上寻找轩辕剑的旅途，与挞拔玉儿、小雪等人结成同伴，共同对抗阴谋与劫难。",
      "围绕上古神器与封印的争夺，故事在历史与神话之间铺展开来，人物在抉择中不断成长。",
      "作品是唐人仙侠剧的代表作之一，江湖气与家国情怀兼具。",
    ],
    characters: [
      {
        name: "陈靖仇",
        actor: "蒋劲夫",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20young%20Chinese%20prince%20warrior%20in%20green%20and%20brown%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20background%20with%20gold%20mist%2C%20earnest%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-12a&orientation=portrait",
        desc: "背负复国使命的少年，从质朴走向担当，在旅途中收获真挚的友情与成长。",
      },
      {
        name: "挞拔玉儿",
        actor: "唐嫣",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20spirited%20young%20Chinese%20tribal%20lady%20in%20red%20and%20green%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20ink%20green%20background%20with%20gold%20light%2C%20bold%20smile%2C%20no%20text&width=420&height=520&seq=xj-char-12b&orientation=portrait",
        desc: "北方部落的少女，爽朗果敢，骑射俱佳。用热烈真挚的情感照亮了同伴的旅程。",
      },
      {
        name: "小雪",
        actor: "古力娜扎",
        image: "https://readdy.ai/api/search-image?query=Stylized%20portrait%20of%20a%20pure%20young%20Chinese%20immortal%20girl%20in%20white%20and%20blue%20robes%2C%20cel%20shaded%20xianxia%20character%20art%2C%20misty%20green%20background%20with%20gold%20light%2C%20gentle%20expression%2C%20no%20text&width=420&height=520&seq=xj-char-12c&orientation=portrait",
        desc: "身负宿命的少女，纯净善良。为守护重要的人甘愿付出一切，令人心疼难忘。",
      },
    ],
  },
];

export const seriesCategories = ["正传", "续集", "衍生", "相关"];
export const seriesRegions = ["大陆", "港台"];
export const seriesEras = [
  { label: "2005 - 2010", min: 2005, max: 2010 },
  { label: "2011 - 2015", min: 2011, max: 2015 },
  { label: "2016 - 2020", min: 2016, max: 2020 },
  { label: "2021 - 至今", min: 2021, max: 2100 },
];

export function getSeriesById(id: string): Series | undefined {
  return seriesList.find((item) => item.id === id);
}